module.exports = __webpack_public_path__ + "PERUVIANserve-2.4017227f.png";